import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { PointOfImpact } from "pages/DamageLocation/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionPointsOfImpactOrderedListAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<PointOfImpact[]>(`pointsOfImpactOrderedList-${sessionId}`, [])
);

export const pointsOfImpactOrderedListAtom = createDerivedSessionAtom<PointOfImpact[]>(
  sessionPointsOfImpactOrderedListAtom
);

export const isValidAtom = atom((get) => get(pointsOfImpactOrderedListAtom).some((selected) => selected));
